export const taxreportdata = [
  {
    id:"1",
    Reference: "#4237300",
    Supplier: "Apex Computers",
    Date: "24 Dec 2024",
    Store: "Electro Mart",
    Amount: "$200",
    Payment_Method: "Stripe",
    Discount: "$200",
    Tax_Amount: "$200",
  },
  {
    id:"2",
    Reference: "#7590325",
    Supplier: "Beats Headphones",
    Date: "10 Dec 2024",
    Store: "Quantum Gadgets",
    Amount: "$50",
    Payment_Method: "Paypal",
    Discount: "$50",
    Tax_Amount: "$50",
  },
  {
    id:"3",
    Reference: "#9814521",
    Supplier: "Dazzle Shoes",
    Date: "27 Nov 2024",
    Store: "Prime Bazaar",
    Amount: "$800",
    Payment_Method: "Cash",
    Discount: "$800",
    Tax_Amount: "$800",
  },
  {
    id:"4",
    Reference: "#8745225",
    Supplier: "Best Accessories",
    Date: "18 Nov 2024",
    Store: "Gadget World",
    Amount: "$100",
    Payment_Method: "Paypal",
    Discount: "$100",
    Tax_Amount: "$100",
  },
  {
    id:"5",
    Reference: "#4237022",
    Supplier: "A-Z Store",
    Date: "06 Nov 2024",
    Store: "Volt Vault",
    Amount: "$700",
    Payment_Method: "Cash",
    Discount: "$700",
    Tax_Amount: "$700",
  },
  {
    id:"6",
    Reference: "#8744439",
    Supplier: "Hatimi Hardwares",
    Date: "25 Oct 2024",
    Store: "Elite Retail",
    Amount: "$1000",
    Payment_Method: "Cash",
    Discount: "$1000",
    Tax_Amount: "$1000",
  },
  {
    id:"7",
    Reference: "#7590365",
    Supplier: "Aesthetic Bags",
    Date: "14 Oct 2024",
    Store: "Prime Mart",
    Amount: "$1200",
    Payment_Method: "Paypal",
    Discount: "$1200",
    Tax_Amount: "$1200",
  },
  {
    id:"8",
    Reference: "#8745478",
    Supplier: "Alpha Mobiles",
    Date: "03 Oct 2024",
    Store: "NeoTech Store",
    Amount: "$750",
    Payment_Method: "Stripe",
    Discount: "$750",
    Tax_Amount: "$750",
  },
  {
    id:"9",
    Reference: "#7590321",
    Supplier: "Sigma Chairs",
    Date: "20 Sep 2024",
    Store: "Urban Mart",
    Amount: "$450",
    Payment_Method: "Stripe",
    Discount: "$450",
    Tax_Amount: "$450",
  },
  {
    id:"10",
    Reference: "#8745245",
    Supplier: "Zenith Bags",
    Date: "10 Sep 2024",
    Store: "Travel Mart",
    Amount: "$300",
    Payment_Method: "Cash",
    Discount: "$300",
    Tax_Amount: "$300",
  },
];

export const salereportdata = [
  {
    id:"1",
    Reference: "#4237300",
    Customer: "Carl Evans",
    Date: "24 Dec 2024",
    Store: "Electro Mart",
    Amount: "$200",
    Payment_Method: "Stripe",
    Discount: "$200",
    Tax_Amount: "$200",
  },
  {
    id:"2",
    Reference: "#7590325",
    Customer: "Minerva Rameriz",
    Date: "10 Dec 2024",
    Store: "Quantum Gadgets",
    Amount: "$50",
    Payment_Method: "Paypal",
    Discount: "$50",
    Tax_Amount: "$50",
  },
  {
    id:"3",
    Reference: "#9814521",
    Customer: "Robert Lamon",
    Date: "27 Nov 2024",
    Store: "Prime Bazaar",
    Amount: "$800",
    Payment_Method: "Cash",
    Discount: "$800",
    Tax_Amount: "$800",
  },
  {
    id:"4",
    Reference: "#8745225",
    Customer: "Patricia Lewis",
    Date: "18 Nov 2024",
    Store: "Gadget World",
    Amount: "$100",
    Payment_Method: "Paypal",
    Discount: "$100",
    Tax_Amount: "$100",
  },
  {
    id:"5",
    Reference: "#4237022",
    Customer: "Mark Joslyn",
    Date: "06 Nov 2024",
    Store: "Volt Vault",
    Amount: "$700",
    Payment_Method: "Cash",
    Discount: "$700",
    Tax_Amount: "$700",
  },
  {
    id:"6",
    Reference: "#8744439",
    Customer: "Marsha Betts",
    Date: "25 Oct 2024",
    Store: "Elite Retail",
    Amount: "$1000",
    Payment_Method: "Cash",
    Discount: "$1000",
    Tax_Amount: "$1000",
  },
  {
    id:"7",
    Reference: "#7590365",
    Customer: "Daniel Jude",
    Date: "14 Oct 2024",
    Store: "Prime Mart",
    Amount: "$1200",
    Payment_Method: "Paypal",
    Discount: "$1200",
    Tax_Amount: "$1200",
  },
  {
    id:"8",
    Reference: "#8745478",
    Customer: "Emma Bates",
    Date: "03 Oct 2024",
    Store: "NeoTech Store",
    Amount: "$750",
    Payment_Method: "Stripe",
    Discount: "$750",
    Tax_Amount: "$750",
  },
  {
    id:"9",
    Reference: "#7590321",
    Customer: "Richard Fralick",
    Date: "20 Sep 2024",
    Store: "Urban Mart",
    Amount: "$450",
    Payment_Method: "Stripe",
    Discount: "$450",
    Tax_Amount: "$450",
  },
  {
    id:"10",
    Reference: "#8745245",
    Customer: "Michelle Robison",
    Date: "10 Sep 2024",
    Store: "Travel Mart",
    Amount: "$300",
    Payment_Method: "Cash",
    Discount: "$300",
    Tax_Amount: "$300",
  },
];
